module.exports = __webpack_public_path__ + "static/DasaSans-Bold-d6be5a7df763da433275972d314a6945.woff2";